import { gql } from 'graphql-tag';

export const GET_EVENT_TYPE = gql`
  query GetEventType($id: ID!) {
    eventType(id: $id) {
      id
      accountId
      name
      color
      createdAt
      updatedAt
      deletedAt
      account {
        id
        name
      }
    }
  }
`;

export const GET_EVENT_TYPES = gql`
  query GetEventTypes($skip: Int, $take: Int) {
    eventTypes(skip: $skip, take: $take) {
      data {
        id
        accountId
        name
        color
        createdAt
        updatedAt
        deletedAt
      }
      total
      page
      limit
    }
  }
`;

export const GET_ALL_EVENT_TYPES = gql`
  query GetAllEventTypes {
    allEventTypes {
      id
      accountId
      name
      color
      createdAt
      updatedAt
      deletedAt
      account {
        id
        name
      }
    }
  }
`;
